import { useState, useEffect } from "react";

import StyledNavbar from "components/styled/Navbar.styled";
import Menu from "./Menu";
import MenuButtons from "./MenuButtons";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (isMenuOpen) {
        document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }

    return () => {
      document.body.style.overflow = ''
    }
}, [isMenuOpen])

  return (
    <StyledNavbar isMenuOpen={isMenuOpen}>
      <MenuButtons isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} showExitButton={false}/>
      <Menu isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <div className="backdrop"></div>
    </StyledNavbar >
  );
};

export default Navbar;
